// extracted by mini-css-extract-plugin
export default {"container_wrapper":"css_container_wrapper__b3li0","container":"css_container__b+G9h","heading":"css_heading__oyLTx","contentBody":"css_contentBody__NJm61"};